import { ChangeDetectionStrategy, Component, Input, OnInit, OnChanges, SimpleChange } from '@angular/core';
import { BaseSearchResultsTableComponent } from './../../shared/base-search-results-table.component';
import { CivilIdentitySearchCase } from '../civil-identity-search-case';

@Component({
  selector: 'app-civil-search-results-table',
  templateUrl: './civil-search-results-table.component.html',
  styleUrls: ['./civil-search-results-table.component.less']
  // ,changeDetection: ChangeDetectionStrategy.OnPush // this class will manage change detection for better performance
})
export class CivilSearchResultsTableComponent extends BaseSearchResultsTableComponent implements OnInit, OnChanges {
   @Input() cases: CivilIdentitySearchCase[];

   pleadingShowFlags: boolean[];
   mouseOverCaseFlags: boolean[];
   pleadingHideNotifyFlags: boolean[];

   /**
    * init
    */
   ngOnInit() {
     super.ngOnInit();
   }

   /**
    * set the flags when the cases was pushed to this compoment
    * @param changes ;
    */
   ngOnChanges(changes: { [propName: string]: SimpleChange}) {
      if (changes['cases'] && this.cases && this.cases.length) {
        this.pleadingShowFlags = new Array(this.cases.length).fill(false, 0, this.cases.length);
        this.mouseOverCaseFlags = new Array(this.cases.length).fill(false, 0, this.cases.length);
        this.pleadingHideNotifyFlags = new Array(this.cases.length).fill(false, 0, this.cases.length);
        setTimeout(() => {
          this.focusViewCaseLink();
        }, 0);
      }
   }

   private focusViewCaseLink() {
    let firstfocusedEleId: string = 'case-search-results-row-' + 0 + '-case-action-view-case-lnk';
    let firstFocusedEle: HTMLElement = document.getElementById(firstfocusedEleId);
    if (firstFocusedEle) {
      setTimeout(() => {
        firstFocusedEle.focus();
      }, 0);
    }
   }

   protected requestFocusForLastViewedCase() {
    this.focusViewCaseLink();
   }



   /**
    * listener for click on show button
    * @param i the index of the row (i.e the index of the case)
    */
   showPleading(i: number) {
      this.pleadingShowFlags[i] = true;
   }

   /**
    * listener for click on hide button, which will set the pleadingHideNorifyFlags[i] (i.e. the ith row).
    * @param i the index of the row (i.e the index of the case)
    */
   hidePleading(i: number) {
      this.pleadingHideNotifyFlags[i] = true;
   }

   /**
    * onPleadingClosed event handler
    * @param i the index of the row (i.e the index of the case)
    */
   onPleadingClosed(i: number) {
     this.pleadingHideNotifyFlags[i] = false;
     this.pleadingShowFlags [i] = false;
   }

   /**
    * listener for mouse over the case row
    * @param i  the index of the row (i.e the index of the case)
    */
   onMouseOverCase(i: number) {
     this.mouseOverCaseFlags[i] = true;
   }

   /**
    * listener for mouse off the case row
    * @param i the index of the row (i.e the index of the case)
    */
   onMouseOffCase(i: number) {
      this.mouseOverCaseFlags[i] = false;
   }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-search-results-table/civil-search-results-table.component.ts